import {
  Button,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

export const ModalWelcomeMessageNotEnabled = ({
  show,
  handleCancel,
  handleConfirm
}) => {
  const intl = useIntl()

  return (
    <Modal
      data-mu-test='modal-welcomeMessageNotEnabled'
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.WelcomeSeries.isWelcomeMessageNotEnabledModalTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.WelcomeSeries.isWelcomeMessageNotEnabledModalDescr'
          })}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='secondary'
          onClick={handleCancel}
          data-mu-test='button-cancel'
        >
          {intl.formatMessage({ id: 'Load.Common.Close' })}
        </Button>
        <Button
          kind='primary'
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({
            id: 'Load.Common.GoToWelcomeEmail'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalWelcomeMessageNotEnabled.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}
